import React, { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { toast } from "sonner";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact", form);
      toast.success("Thanks — we'll be in touch.");
      setForm({ name: "", email: "", message: "" });
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Failed to send"); }
    finally { setLoading(false); }
  };

  return (
    <div className="max-w-2xl mx-auto px-4 py-14">
      <h1 className="font-heading text-4xl font-bold text-gray-900">Contact us</h1>
      <p className="mt-3 text-gray-700">Questions, partnerships or feedback — we'd love to hear from you.</p>
      <Card className="mt-8 border-2 border-gray-900 rounded-xl">
        <CardContent className="p-8">
          <form onSubmit={submit} className="space-y-5">
            <div>
              <Label htmlFor="cname" className="text-lg font-medium">Name</Label>
              <Input id="cname" required value={form.name} onChange={e => setForm(f => ({...f, name: e.target.value}))}
                className="mt-2 h-12 border-2 border-gray-300 focus:border-blue-600" data-testid="contact-name"/>
            </div>
            <div>
              <Label htmlFor="cemail" className="text-lg font-medium">Email</Label>
              <Input id="cemail" type="email" required value={form.email} onChange={e => setForm(f => ({...f, email: e.target.value}))}
                className="mt-2 h-12 border-2 border-gray-300 focus:border-blue-600" data-testid="contact-email"/>
            </div>
            <div>
              <Label htmlFor="cmsg" className="text-lg font-medium">Message</Label>
              <Textarea id="cmsg" required rows={5} value={form.message} onChange={e => setForm(f => ({...f, message: e.target.value}))}
                className="mt-2 border-2 border-gray-300 focus:border-blue-600" data-testid="contact-message"/>
            </div>
            <Button disabled={loading} className="w-full h-12 rounded-full bg-blue-600 hover:bg-blue-700" data-testid="contact-submit">
              {loading ? "Sending…" : "Send message"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
